'use client';

import {usePurchase, usePurchaseParams} from '@/hooks/purchase';
import {usePurchaseContext} from './PurchaseProvider';
import {useCallback, useEffect, useState} from 'react';
import {PurchaseActiveActions} from './types';
import {PurchaseReceipt} from '@/types';

export const PurchaseTrigger = () => {
	const [purchaseInProgress, setPurchaseInProgress] = useState(false);
	const {merchantGroup, salesChannel} = usePurchaseParams();

	const {
		offerId = '',
		sandboxId = '',
		offerType,
		state: purchaseState,
		actions,
		setReceipt
	} = usePurchaseContext<'checkout' | 'inactive'>();

	const activeActions = actions as PurchaseActiveActions; // type

	const {buyOrSignIn} = usePurchase({
		offerId,
		sandboxId,
		offerType,
		merchantGroup,
		salesChannel
	});

	const onSuccess = useCallback(
		(purchaseResult: PurchaseReceipt | undefined) => {
			if (purchaseResult?.TransactionState === 'Purchased') {
				activeActions.checkout.next();
				if (purchaseResult) {
					setReceipt(purchaseResult);
				}
			} else {
				activeActions.checkout.cancel();
			}
			setPurchaseInProgress(false);
		},
		[actions, setReceipt]
	);

	const onError = useCallback(() => {
		activeActions.checkout.cancel();
		setPurchaseInProgress(false);
	}, [actions]);

	useEffect(() => {
		if (purchaseState === 'checkout' && !purchaseInProgress) {
			setPurchaseInProgress(true);
			buyOrSignIn()
				.then((result) => onSuccess(result as unknown as PurchaseReceipt))
				.catch(onError);
		}
	}, [buyOrSignIn, purchaseState, onError, onSuccess]);

	return null;
};
